import {BaseService} from "./BaseService";
import ReferenceModel from "../Models/ReferenceModel";
import {AxiosResponse} from "axios";
import ApiResponse from "../Models/ApiResponse";
import api from "../Interceptors/Interceptor";
import {IFavouriteModel} from "./DashboardFavouriteService";

export interface ICrudConversationModel {
    uuid: string
    conversationType: ReferenceModel
    customer?: ReferenceModel
    title: string
    sequence: number
    active: boolean
}

export interface IConversationModel {
	uuid: string
	conversationType: ReferenceModel
	customer?: ReferenceModel
	title: string
	location: string
	locationIdentifier: string
	sequence: number
	active: boolean
}

export interface  IConversationMessageModel {
	uuid: string
	conversationMessageType: ReferenceModel
	message: string
	messageSentTs: string
	metadata: IConversationMessageMetadataModel[] | undefined
	createdBy: ReferenceModel
	active: boolean
}

export interface  IConversationMessageMetadataModel {
	key: string
	value: string
}

export interface IConversationChatMessageModel {
	message: string
	/** Applied dashboard filters (IChartJsFilterModel) for dashboard-scoped Ask AI SETUP queries. */
	dashboardFilters?: Record<string, any>
}

export class ConversationService extends BaseService<ICrudConversationModel, ICrudConversationModel> {

	public async fetchMessages(uuid: string, params?: any): Promise<AxiosResponse<ApiResponse<IConversationMessageModel[]>>> {
		return await api.get(`v1/${this.modelUrl()}/${uuid}/messages`, {params: params});
	}

	public async fetchSubjectSearch(input: string): Promise<AxiosResponse<ApiResponse<string[]>>> {
		return await api.get(`v1/${this.modelUrl()}/subject/search`, {
			params: {
				q: input
			}
		});
	}

	public async postMessage(uuid: string, message: IConversationChatMessageModel): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.post(`v1/${this.modelUrl()}/${uuid}/message`, message);
	}

	public async postStandaloneMessage(message: IConversationChatMessageModel): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.post(`v1/${this.modelUrl()}/message`, message);
	}

    protected modelUrl(): string {
        return "conversation";
    }

}